(() => {
  const OUTPUT_SELECTOR = '[data-lw-series-output]';
  const SOURCE_SELECTOR = '.lw-series-source';

  function getSeriesCount(value) {
    if (!value) return 1;

    const normalized = String(value)
      .replace(/[–—/,]/g, '-')
      .replace(/\s+/g, '')
      .trim();

    if (!normalized.includes('-')) return 1;

    const numbers = normalized.match(/\d+/g)?.map(Number).filter(Number.isFinite) ?? [];
    if (numbers.length >= 3) return numbers.length;

    if (numbers.length === 2) {
      const [start, end] = numbers;
      if (end >= start && (end - start) % 2 === 0) {
        return (end - start) / 2 + 1;
      }
      return 2;
    }

    return 1;
  }

  function getCurrency() {
    return window.Shopify?.currency?.active || 'EUR';
  }

  function formatMoney(cents) {
    const amount = Number(cents) / 100;
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'de-DE',
        {
          style: 'currency',
          currency: getCurrency(),
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      ).format(amount);
    } catch {
      return `${amount.toFixed(2).replace('.', ',')} €`;
    }
  }

  function renderSeriesPrice(output) {
    const isApprovedB2B = document.body.classList.contains('lw-b2b-approved');

    if (!isApprovedB2B) {
      output.hidden = true;
      output.replaceChildren();
      return;
    }

    const container =
      output.closest('product-price') ||
      output.closest('product-card') ||
      output.closest('.resource-card') ||
      output.closest('.lw-product') ||
      output.parentElement;

    let source = container?.querySelector(SOURCE_SELECTOR) || null;
    if (!source && output.previousElementSibling?.matches?.(SOURCE_SELECTOR)) {
      source = output.previousElementSibling;
    }

    if (!source) {
      output.hidden = true;
      output.replaceChildren();
      return;
    }

    const sizeValue = source.dataset.lwSizeValue || '';
    const priceCents = Number(source.dataset.lwPriceCents || 0);
    const seriesCount = getSeriesCount(sizeValue);

    if (seriesCount <= 1 || !priceCents) {
      output.hidden = true;
      output.replaceChildren();
      return;
    }

    const unitCents = Math.round(priceCents / seriesCount);
    const exact = priceCents % seriesCount === 0;

    const label = document.createElement('span');
    label.className = 'lw-series-price__label';
    label.textContent = `Serienpreis für ${seriesCount} Kleider`;

    const unit = document.createElement('strong');
    unit.className = 'lw-series-price__unit';
    unit.textContent = `Preis pro Kleid: ${exact ? '' : 'ca. '}${formatMoney(unitCents)}`;

    output.replaceChildren(label, unit);
    output.hidden = false;
  }

  let scheduled = false;
  function updateAll() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll(OUTPUT_SELECTOR).forEach(renderSeriesPrice);
    });
  }

  document.addEventListener('DOMContentLoaded', updateAll);
  document.addEventListener('change', (event) => {
    if (event.target.closest?.('variant-picker')) {
      setTimeout(updateAll, 80);
      setTimeout(updateAll, 350);
    }
  });

  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) =>
      [...mutation.addedNodes].some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (
            node.matches?.('product-price, product-card, .lw-series-source, [data-lw-series-output]') ||
            node.querySelector?.('product-price, product-card, .lw-series-source, [data-lw-series-output]')
          )
      )
    );

    if (relevant) updateAll();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  updateAll();
})();
